import { useRef } from "react";
import { Button, BUTTON_SIZE } from "components/UI/Button";
import { FileImport, Plus, TruckFront } from "components/UI/Icons";
import { COLORS } from "constants/colors.constants";
import { useAppDispatch } from "hooks/useAppDispatch";
import { useTranslation } from "localization/localization";
import { addCargoRow } from "store";
import { CargoEmptyProps } from "./CargoEmpty.types";
import s from "./CargoEmpty.module.scss";

export const CargoEmpty = ({ groupId, onImport }: CargoEmptyProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const importInputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={s.wrapper}>
      <div className={s.content}>
        <TruckFront className={s.icon} />
        <h4 className={s.title}>{t("No cargo added yet")}</h4>
        <p className={s.subtitle}>
          {t("To begin, add cargo items to your packing list. You can import them or create manually.")}
        </p>
      </div>
      <div className={s.actions}>
        <input
          ref={importInputRef}
          type="file"
          accept=".xlsx, .xls"
          className={s.hiddenInput}
          onChange={(event) => onImport(event, groupId)}
        />
        <Button className={s.btn} size={BUTTON_SIZE.L} onClick={() => importInputRef.current?.click()}>
          <FileImport color={COLORS.WHITE} />
          {t("Import")}
        </Button>
        <Button className={s.btn} size={BUTTON_SIZE.L} onClick={() => dispatch(addCargoRow(groupId))}>
          <Plus />
          {t("Add cargo")}
        </Button>
      </div>
    </div>
  );
};
